export const usernameValidation = { required: true };

export const passwordValidation = { required: true };
